
  <div class="row" style="height:900px; width: 100%;">
    <iframe [src]="srcUrl | safeUrl" style="height:100%; width: 100%;"></iframe>
  </div>
